// Action Types
export const VM_GET_TOTAL_EARNING = "VM_GET_TOTAL_EARNING";
export const VM_SET_TOTAL_EARNING = "VM_SET_TOTAL_EARNING";

export const VM_GET_AGENCY_EARNINGS = "VM_GET_AGENCY_EARNINGS";
export const VM_SET_AGENCY_EARNINGS = "VM_SET_AGENCY_EARNINGS";

export const VM_GET_VENDOR_EARNINGS = "VM_GET_VENDOR_EARNINGS";
export const VM_SET_VENDOR_EARNINGS = "VM_SET_VENDOR_EARNINGS";

export const VM_GET_POS_FOR_INVOICE = "VM_GET_POS_FOR_INVOICE";
export const VM_GET_DEBOUNCE_POS_FOR_INVOICE =
  "VM_GET_DEBOUNCE_POS_FOR_INVOICE";
export const VM_SET_POS_FOR_INVOICE = "VM_SET_POS_FOR_INVOICE";
export const VM_SET_LOAD_MORE_POS_FOR_INVOICE =
  "VM_SET_LOAD_MORE_POS_FOR_INVOICE";

export const VM_SUBMIT_INVOICE_REQUEST = "VM_SUBMIT_INVOICE_REQUEST";

export const VM_UPDATE_EARNING_STATUS = "VM_UPDATE_EARNING_STATUS";

// Action Creators
export const getTotalEarning = (cb = () => {}) => ({
  type: VM_GET_TOTAL_EARNING,
  cb,
});
export const setTotalEarning = (
  data = { totalEarning: 0, pendingEarning: 0, paidEarning: 0, dueToday: 0 }
) => ({
  type: VM_SET_TOTAL_EARNING,
  payload: data,
});

export const getAgencyEarnings = (agencyId, query, cb = () => {}) => ({
  type: VM_GET_AGENCY_EARNINGS,
  agencyId,
  query,
  cb,
});
export const setAgencyEarnings = (data = { result: [], count: 0 }) => ({
  type: VM_SET_AGENCY_EARNINGS,
  payload: data,
});

export const getVendorEarnings = (vendorId, query, cb = () => {}) => ({
  type: VM_GET_VENDOR_EARNINGS,
  vendorId,
  query,
  cb,
});
export const setVendorEarnings = (data = { result: [], count: 0 }) => ({
  type: VM_SET_VENDOR_EARNINGS,
  payload: data,
});

export const getPosForInvoice = (query, isLoadMore = false, cb = () => {}) => ({
  type: VM_GET_POS_FOR_INVOICE,
  query,
  isLoadMore,
  cb,
});

export const getDebouncePosForInvoice = (
  query,
  isLoadMore = false,
  cb = () => {}
) => ({
  type: VM_GET_DEBOUNCE_POS_FOR_INVOICE,
  query,
  isLoadMore,
  cb,
});

export const setPosForInvoice = (data = { result: [], count: 0 }) => ({
  type: VM_SET_POS_FOR_INVOICE,
  payload: data,
});

export const setMorePosForInvoice = (data = { result: [], count: 0 }) => ({
  type: VM_SET_LOAD_MORE_POS_FOR_INVOICE,
  payload: data,
});

export const submitInvoiceRequest = (payload, cb = () => {}) => ({
  type: VM_SUBMIT_INVOICE_REQUEST,
  payload,
  cb,
});

export const updateEarningStatus = ({ isAgency, assigneeId, status }) => ({
  type: VM_UPDATE_EARNING_STATUS,
  isAgency,
  assigneeId,
  status,
});
